import { PATH_STATIC_USER_IMAGES } from 'src/routes';

import { TUserType, TUserTypeResponse, adaptUserTypeFromResponse } from './user-type.type';


export type TUserCard = {
  nickname: string;
  isActive?: boolean;
  image: string;
	createdAt: string;
  updatedAt: string;

	phoneNumber?: string;
	email?: string;
	type?: TUserType;
	salary?: number;
};

export type TUserCardResponse = {
  nickname: string;
  is_active: boolean;
  image?: string;
  created_at: string;
  updated_at: string;

	phone_number?: string;
	email?: string;
	type?: TUserTypeResponse;
	salary?: number;
};

export function adaptUserCardFromResponse(data: TUserCardResponse): TUserCard {
	const {
		nickname,
		is_active: isActive,
		created_at: createdAt,
		updated_at: updatedAt,
		image: imageRaw,
		phone_number: phoneNumber,
		email,
		type: typeRaw,
		salary,
	} = data;

	const image = imageRaw ? `${PATH_STATIC_USER_IMAGES}/${imageRaw}` : PATH_STATIC_USER_IMAGES;
	const type = typeRaw ? adaptUserTypeFromResponse(typeRaw) : undefined;

	return {
		nickname,
		isActive,
		image,
		phoneNumber,
		email,
		type,
		salary,
		createdAt,
		updatedAt,
	};
}
